module.exports = __webpack_public_path__ + "static/media/frame.5ad6d917.svg";